module.exports = __webpack_public_path__ + "static/media/Impact.342d8779.svg";